<template>
  <div class="city-select">

    <transition name="fade">
      <div class="veil" v-if="panelOpened" @click="panelOpened = false"></div>
    </transition>
    <transition name="slide">
      <div :class="['side-panel', {'side-panel_opened': panelOpened}]" v-if="panelOpened">
        <div class="side-panel__inner">
          <span class="side-panel__close" @click="panelOpened = false"></span>
          <div class="city-select__pannel-content">
            <h2 class="city-select__search-title">выберите свой город</h2>
            <branches-list :use-spans="useSpans" :branches-data="citiesData" in-panel
                           :display-we-work-banner="displayWeWorkBanner"></branches-list>
          </div>
        </div>
      </div>
    </transition>
    <a href="" class="button button_small button_bordered city-select__select-button" @click.prevent="panelOpened = true;">
      {{ currentCity }}
      <svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0H4H8L4 8L0 0Z" fill="#292929"/></svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CitySelect',
  props: {
    currentCity: {
      type: String,
      default: 'не выбрано'
    },
    citiesData: {
      type: Array,
      default: () => [],
    },
    useSpans: {
      type: Boolean,
      default: true,
    },
    displayWeWorkBanner: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BranchesList: () => import('../components/BranchesList.vue'),
  },
  data() {
    return {
      panelOpened: false,
    }
  },
  watch: {
    panelOpened(newBool) {
      if (newBool) {
        document.body.style.overflow = 'hidden';
        return;
      }
      document.body.style.overflow = '';
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
